import React, {useContext, useEffect, useState, useMemo} from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {empty, req_cust_approve, req_cust_area, req_cust_category, req_cust_chain, req_cust_insert, req_cust_type, req_module_setting, req_salesman, req_stocktemplate} from '../../Helper/Constants';
import AppContext from '../../Services/AppContext';
import {useSnackbar} from 'notistack';
import Typography from '@material-ui/core/Typography';
import {useCommonStyles} from '../../Styles';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import AddIcon from '@material-ui/icons/Add';
import _ from 'lodash';
import VirtualListCB2 from '../../Components/VirtualListCB2';
import {useMediaQuery, useTheme} from '@material-ui/core';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {de, getSetting} from '../../Helper/Helper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { red } from '@material-ui/core/colors';
import AddAreaType from '../../Components/AddAreaType';
import AddCustType from '../../Components/AddCustType';
import AddCustChain from '../../Components/AddCustChain';
import AddCustCategory from '../../Components/AddCustCategory';

const useStyles = makeStyles((theme) => ({
	dlg: {
		minWidth: 300,
		margin: 5,
		marginLeft: 20,
		marginRight: 20
	},
	total: {
		float: 'left',
		color: 'grey',
		fontWeight: 'bold'
	},
	viewInRowSpace: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between'
	},
	btn:{
		width:'100%',
		height:50,
		textAlign:'center',
		fontSize:12
	},
	error:{
		color: `${red[500]} !important`,
		borderColor: `${red[400]} !important`,
		'&:hover': {
			borderColor: `${red[500]} !important`,
		}
	}
}));

const outlets = [
	{
		name: "supermarket"
	},
	{
		name: "hypermarket"
	},
	{
		name: "wholesales"
	}
];

const options = [{'name':'Option 1','value':'Option 1'}, {'name':'Option 2','value':'Option 2'}];

export default function AddCustomer({open, onClose, onSaved, language, salesperson = '', currentCustomer = null, custCategoryList = [], custChainList = [], custTypeList = [], custAreaList = [], branchesList = [], currentInput = null, onCancel, stockTemplateList = [], agentList = []}) {
	const commonStyle = useCommonStyles();
	const classes = useStyles();
	const [gState] = useContext(AppContext);
	const [axiosConfig, setAxiosConfig] = useState({});
	const [custAreaOptions, setCustAreaOptions] = useState(custAreaList || []);
	const [newCustAreaView, setNewCustAreaView] = useState(false);
	const [custTypeOptions, setCustTypeOptions] = useState(custTypeList || []);
	const [newCustTypeView, setNewCustTypeView] = useState(false);
	const [custChainOptions, setCustChainOptions] = useState(custChainList || []);
	const [newCustChainView, setNewCustChainView] = useState(false);
	const [custCategoryOptions, setCustCategoryOptions] = useState(custCategoryList || []);
	const [newCustCategoryView, setNewCustCategoryView] = useState(false);

	const {enqueueSnackbar, closeSnackbar} = useSnackbar();
	const [customer, setCustomer] = useState(currentCustomer);
	const [custCode, setCustCode] = useState(empty);
	const [custName, setCustName] = useState(empty);
	const [custAddress1, setCustAddress1] = useState(empty);
	const [custAddress2, setCustAddress2] = useState(empty);
	const [state, setState] = useState(empty);
	const [city, setCity] = useState(empty);
	const [postCode, setPostCode] = useState(empty);
	const [country, setCountry] = useState(empty);
	const [region, setRegion] = useState(empty);
	const [splist, setSPlist] = useState([]);
	const [spView, setSpView] = useState(false);
	const [spValue, setSpValue] = useState(empty);
	const [spSelect, setSpSelected] = useState(empty);
	const [spSelectBranch, setSpSelectBranch] = useState([]);
	const [outletType, setOutletType] = useState(empty);
	const [longitude, setLongitude] = useState(empty);
	const [latitude, setLatitude] = useState(empty);
	const [latlong, setLatlong] = useState(empty);
	const [countries, setCountries] = useState([]);
	const [custCategory, setCustCategory] = useState({});
	const [custChain, setCustChain] = useState({});
	const [custType, setCustType] = useState({});
	const [custArea, setCustArea] = useState({});
	const [custCategoryName, setCustCategoryName] = useState(empty);
	const [custChainName, setCustChainName] = useState(empty);
	const [custTypeName, setCustTypeName] = useState(empty);
	const [custAreaName, setCustAreaName] = useState(empty);
	const [custCategoryId, setCustCategoryId] = useState(0);
	const [custChainId, setCustChainId] = useState(0);
	const [custTyperId, setCustTypeId] = useState(0);
	const [custAreaCode, setCustAreaCode] = useState(empty);
	const [value, setValue] = useState({});
	const [inputValue, setInputValue] = useState('');
	const [nextCustCode, setNextCustCode] = useState('');
	const [custCodeProps, setCustCodeProps] = useState(20);
	const [mobileCheckinID, setMobileCheckinID] = useState(empty);
	const [autoCapsOutletName, setAutoCapsOutletName] = useState(false);
	const [selectedBranch, setSelectedBranch] = useState([]);
	const [selectedStockTemplates, setSelectedStockTemplates] = useState([]);
	const [stockTemplateNames, setStockTemplateNames] = useState(empty);
	const [stockTemplateIds, setStockTemplateIds] = useState([]);

	const cannotADDorEDIT = useMemo(() => {
		if (branchesList.length > 0) {
			if(spSelect && spSelect !== empty && spSelect !== ''){
				if(selectedBranch.length > 0){
					const allBranchesSelected = spSelectBranch.every(branch => selectedBranch.includes(branch));
					return !allBranchesSelected;
				}else{
					return true;
				}
			} else {
				return false;
			}
		}
		return false;
	}, [branchesList, spSelect, selectedBranch, spSelectBranch]);

	useEffect(() => {
		var axiosGetConfig = axiosDefaultConfig(gState.client);
		setAxiosConfig(axiosGetConfig);
		getSalesmanList(axiosGetConfig);
		getCountry(axiosGetConfig);
		if (salesperson != '') {
			setSpSelected(salesperson);
		}
		if (customer) {
			setCustCode(customer?.cust_code);
			setCustName(customer?.cust_company_name);
			setState(customer?.billing_state);
			setCustAddress1(customer?.billing_address1);
			setCustAddress2(customer?.billing_address2);
			setCity(customer?.billing_city);
			setPostCode(customer?.billing_zipcode);
			setCountry(customer?.billing_country);
			setRegion(customer?.region);
			// setLatitude(customer?.latitude);
			// setLongitude(customer?.longitude);
			setLatlong(customer?.latitude+","+customer?.longitude);
			// Re-derive the four lookups from the saved outlet on every open. Names fall back to the
			// outlet's own fields when the item is missing from the option lists, so saved values are not blanked.
			const savedCategory = custCategoryOptions.find((x) => getCustCategoryId(x) == customer?.cust_category);
			setCustCategory(savedCategory || {});
			setCustCategoryName(savedCategory?.cust_category_name || customer?.cust_category_name || empty);
			setCustCategoryId(customer?.cust_category || 0);

			const savedChain = custChainOptions.find((x) => getCustChainId(x) == customer?.cust_chain);
			setCustChain(savedChain || {});
			setCustChainName(savedChain?.cust_chain_name || customer?.cust_chain_name || empty);
			setCustChainId(customer?.cust_chain || 0);

			const savedType = custTypeOptions.find((x) => getCustTypeId(x) == customer?.cust_type);
			setCustType(savedType || {});
			setCustTypeName(savedType?.name || customer?.cust_type_name || empty);
			setCustTypeId(customer?.cust_type || 0);

			const savedArea = custAreaOptions.find((x) => getCustAreaCode(x) == customer?.cust_area);
			setCustArea(savedArea || {});
			setCustAreaName(savedArea?.area_name || customer?.area_name || empty);
			setCustAreaCode(customer?.cust_area || empty);
			// 处理 tmplt_data 数组格式的数据
			if (customer?.tmplt_data && Array.isArray(customer.tmplt_data)) {
				const selectedTemplates = [];
				const templateNames = [];
				const templateIds = [];
				
				for (let i = 0; i < customer.tmplt_data.length; i++) {
					const tmpltData = customer.tmplt_data[i];
					// 在 stockTemplateList 中查找对应的完整模板对象
					for (let k = 0; k < stockTemplateList.length; k++) {
						const element = stockTemplateList[k];
						// 兼容 id 和 tmplt_id 两种字段名
						const tmpltId = tmpltData.tmplt_id || tmpltData.id;
						if(element.id == tmpltId){
							selectedTemplates.push(element);
							templateNames.push(element.tmplt_name);
							templateIds.push(element.id.toString());
							break;
						}
					}
				}
				
				setSelectedStockTemplates(selectedTemplates);
				setStockTemplateNames(templateNames.join(', '));
				setStockTemplateIds(templateIds);
			}
			// 兼容旧的 stock_template_ids 字符串格式
			else if (customer?.stock_template_ids) {
				const templateIds = customer.stock_template_ids.split(',');
				const selectedTemplates = [];
				const templateNames = [];
				for (let k = 0; k < stockTemplateList.length; k++) {
					const element = stockTemplateList[k];
					if(templateIds.includes(element.id.toString())){
						selectedTemplates.push(element);
						templateNames.push(element.tmplt_name);
					}
				}
				setSelectedStockTemplates(selectedTemplates);
				setStockTemplateNames(templateNames.join(', '));
				setStockTemplateIds(templateIds);
			}
			if (customer.company) {
				setSelectedBranch(JSON.parse(customer.company));
				setSpSelectBranch(JSON.parse(customer.company));
			}
		} else {
			if (gState.company) {
				setSelectedBranch(JSON.parse(gState.company));
				setSpSelectBranch(JSON.parse(gState.company));
			}
		}

		if (agentList && agentList.length > 0) {
			var spValue = '';
			var spName = '';
			for (let i = 0; i < agentList.length; i++) {
				if(i == agentList.length - 1){
					spValue += agentList[i].staff_code;
					spName += agentList[i].name;
				}else{
					spValue += agentList[i].staff_code + ",";
					spName += agentList[i].name + ",";
				}
			}
			setSpValue(spValue);
			setSpSelected(spName);
		}
		// de("betty", custChainList, custTypeList, branchesList);
	}, [open]);

	const custAreaListSignature = useMemo(() => {
		const incoming = custAreaList || [];
		return incoming.map((x) => x?.area_code || x?.code || x?.value || empty).join('|');
	}, [custAreaList]);

	const custTypeListSignature = useMemo(() => {
		const incoming = custTypeList || [];
		return incoming.map((x) => x?.id || x?.cust_type_id || x?.value || empty).join('|');
	}, [custTypeList]);

	const custChainListSignature = useMemo(() => {
		const incoming = custChainList || [];
		return incoming.map((x) => x?.cust_chain_id || x?.id || x?.value || empty).join('|');
	}, [custChainList]);

	const custCategoryListSignature = useMemo(() => {
		const incoming = custCategoryList || [];
		return incoming.map((x) => x?.cust_category_id || x?.id || x?.value || empty).join('|');
	}, [custCategoryList]);

	useEffect(() => {
		const incoming = custAreaList || [];
		setCustAreaOptions((prev) => {
			if (!prev || prev.length === 0) {
				return incoming.map((x) => normalizeCustArea(x));
			}
			const normalizedIncoming = incoming.map((x) => normalizeCustArea(x));
			const extra = (prev || []).filter((p) => !normalizedIncoming.some((i) => getCustAreaCode(i) === getCustAreaCode(p)));
			return [...normalizedIncoming, ...extra];
		});
	}, [custAreaListSignature]);

	useEffect(() => {
		const incoming = custTypeList || [];
		setCustTypeOptions((prev) => {
			if (!prev || prev.length === 0) {
				return incoming.map((x) => normalizeCustType(x));
			}
			const normalizedIncoming = incoming.map((x) => normalizeCustType(x));
			const extra = (prev || []).filter((p) => !normalizedIncoming.some((i) => getCustTypeId(i) === getCustTypeId(p)));
			return [...normalizedIncoming, ...extra];
		});
	}, [custTypeListSignature]);

	useEffect(() => {
		const incoming = custChainList || [];
		setCustChainOptions((prev) => {
			if (!prev || prev.length === 0) {
				return incoming.map((x) => normalizeCustChain(x));
			}
			const normalizedIncoming = incoming.map((x) => normalizeCustChain(x));
			const extra = (prev || []).filter((p) => !normalizedIncoming.some((i) => getCustChainId(i) === getCustChainId(p)));
			return [...normalizedIncoming, ...extra];
		});
	}, [custChainListSignature]);

	useEffect(() => {
		const incoming = custCategoryList || [];
		setCustCategoryOptions((prev) => {
			if (!prev || prev.length === 0) {
				return incoming.map((x) => normalizeCustCategory(x));
			}
			const normalizedIncoming = incoming.map((x) => normalizeCustCategory(x));
			const extra = (prev || []).filter((p) => !normalizedIncoming.some((i) => getCustCategoryId(i) === getCustCategoryId(p)));
			return [...normalizedIncoming, ...extra];
		});
	}, [custCategoryListSignature]);

	const getCustAreaCode = (area) => {
		return area?.area_code || area?.code || area?.value || empty;
	}

	const normalizeCustArea = (area) => {
		if (_.isEmpty(area)) {
			return {};
		}
		const area_code = getCustAreaCode(area);
		const area_name = area?.area_name || area?.name || empty;
		return {
			...area,
			area_code,
			area_name
		};
	}

	const getCustTypeId = (type) => {
		return type?.id || type?.cust_type_id || type?.value || empty;
	}

	const normalizeCustType = (type) => {
		if (_.isEmpty(type)) {
			return {};
		}
		const id = getCustTypeId(type);
		const name = type?.name || type?.cust_type_name || empty;
		const code = type?.code || type?.cust_type_code || empty;
		return {
			...type,
			id,
			name,
			code
		};
	}

	const getCustChainId = (chain) => {
		return chain?.cust_chain_id || chain?.id || chain?.value || empty;
	}

	const normalizeCustChain = (chain) => {
		if (_.isEmpty(chain)) {
			return {};
		}
		const cust_chain_id = getCustChainId(chain);
		const cust_chain_name = chain?.cust_chain_name || chain?.name || empty;
		const cust_chain_code = chain?.cust_chain_code || chain?.code || empty;
		return {
			...chain,
			cust_chain_id,
			cust_chain_name,
			cust_chain_code
		};
	}

	const getCustCategoryId = (category) => {
		return category?.cust_category_id || category?.id || category?.value || empty;
	}

	const normalizeCustCategory = (category) => {
		if (_.isEmpty(category)) {
			return {};
		}
		const cust_category_id = getCustCategoryId(category);
		const cust_category_name = category?.cust_category_name || category?.name || empty;
		const cust_category_code = category?.cust_category_code || category?.code || empty;
		return {
			...category,
			cust_category_id,
			cust_category_name,
			cust_category_code
		};
	}

	const loadCustAreaList = (config = axiosConfig) => {
		const axiosGetConfig = _.isEmpty(config) ? axiosDefaultConfig(gState.client) : config;
		return API_Service.get(req_cust_area, axiosGetConfig)
			.then(({data}) => {
				if (data) {
					var {result, extraData} = data;
					if (parseInt(result) === 1) {
						var _act_data = [];
						for (let i = 0; i < extraData.length; i++) {
							const element = extraData[i];
							if (parseInt(element?.area_status) === 1) {
								_act_data.push(normalizeCustArea(element));
							}
						}
						setCustAreaOptions((prev) => {
							const extra = (prev || []).filter((p) => !_act_data.some((i) => getCustAreaCode(i) === getCustAreaCode(p)));
							return [..._act_data, ...extra];
						});
						return _act_data;
					}
				}
				return [];
			})
			.catch((err) => {
				de(err.message, 'customer area list');
				return [];
			});
	}

	const applyCustArea = (area) => {
		const normalized = normalizeCustArea(area);
		if (_.isEmpty(normalized)) {
			setCustArea({});
			setCustAreaName(empty);
			setCustAreaCode(empty);
			return;
		}
		setCustArea(normalized);
		setCustAreaName(normalized?.area_name || empty);
		setCustAreaCode(normalized?.area_code || empty);
	}

	const onAddCustAreaClose = (data) => {
		setNewCustAreaView(false);
		if (!_.isEmpty(data)) {
			const normalized = normalizeCustArea(data);
			const newAreaCode = getCustAreaCode(normalized);
			setCustAreaOptions((prev) => {
				if (!newAreaCode) {
					return prev || [];
				}
				if ((prev || []).some((p) => getCustAreaCode(p) === newAreaCode)) {
					return prev || [];
				}
				return [normalized, ...(prev || [])];
			});
			applyCustArea(normalized);
			if (customer?.cust_code) {
				editCustomer({cust_area: newAreaCode}, true);
			}
			loadCustAreaList().then((list) => {
				if (!newAreaCode) {
					return;
				}
				const matched = list.find((x) => x.area_code === newAreaCode);
				if (!_.isEmpty(matched)) {
					applyCustArea(matched);
				}
			});
		}
	}

	const loadCustTypeList = (config = axiosConfig) => {
		const axiosGetConfig = _.isEmpty(config) ? axiosDefaultConfig(gState.client) : config;
		return API_Service.get(req_cust_type, axiosGetConfig)
			.then(({data}) => {
				if (data) {
					var {result, extraData} = data;
					if (parseInt(result) === 1) {
						var _act_data = [];
						for (let i = 0; i < extraData.length; i++) {
							const element = extraData[i];
							if (parseInt(element?.status) === 1) {
								_act_data.push(normalizeCustType(element));
							}
						}
						setCustTypeOptions((prev) => {
							const extra = (prev || []).filter((p) => !_act_data.some((i) => getCustTypeId(i) === getCustTypeId(p)));
							return [..._act_data, ...extra];
						});
						return _act_data;
					}
				}
				return [];
			})
			.catch((err) => {
				de(err.message, 'customer type list');
				return [];
			});
	}

	const applyCustType = (type) => {
		const normalized = normalizeCustType(type);
		if (_.isEmpty(normalized)) {
			setCustType({});
			setCustTypeName(empty);
			setCustTypeId(empty);
			return;
		}
		setCustType(normalized);
		setCustTypeName(normalized?.name || empty);
		setCustTypeId(normalized?.id || empty);
	}

	const onAddCustTypeClose = (data) => {
		setNewCustTypeView(false);
		if (!_.isEmpty(data)) {
			const normalized = normalizeCustType(data);
			const newId = getCustTypeId(normalized);
			setCustTypeOptions((prev) => {
				if (!newId) {
					return prev || [];
				}
				if ((prev || []).some((p) => getCustTypeId(p) === newId)) {
					return prev || [];
				}
				return [normalized, ...(prev || [])];
			});
			applyCustType(normalized);
			if (customer?.cust_code) {
				editCustomer({cust_type: newId, display: {cust_type_name: normalized.name}}, true);
			}
			loadCustTypeList().then((list) => {
				if (!newId) {
					return;
				}
				const matched = list.find((x) => getCustTypeId(x) === newId);
				if (!_.isEmpty(matched)) {
					applyCustType(matched);
				}
			});
		}
	}

	const loadCustChainList = (config = axiosConfig) => {
		const axiosGetConfig = _.isEmpty(config) ? axiosDefaultConfig(gState.client) : config;
		return API_Service.get(req_cust_chain, axiosGetConfig)
			.then(({data}) => {
				if (data) {
					var {result, extraData} = data;
					if (parseInt(result) === 1) {
						var _act_data = [];
						for (let i = 0; i < extraData.length; i++) {
							const element = extraData[i];
							if (parseInt(element?.cust_chain_status) === 1) {
								_act_data.push(normalizeCustChain(element));
							}
						}
						setCustChainOptions((prev) => {
							const extra = (prev || []).filter((p) => !_act_data.some((i) => getCustChainId(i) === getCustChainId(p)));
							return [..._act_data, ...extra];
						});
						return _act_data;
					}
				}
				return [];
			})
			.catch((err) => {
				de(err.message, 'customer chain list');
				return [];
			});
	}

	const applyCustChain = (chain) => {
		const normalized = normalizeCustChain(chain);
		if (_.isEmpty(normalized)) {
			setCustChain({});
			setCustChainName(empty);
			setCustChainId(0);
			return;
		}
		setCustChain(normalized);
		setCustChainName(normalized?.cust_chain_name || empty);
		setCustChainId(normalized?.cust_chain_id || 0);
	}

	const onAddCustChainClose = (data) => {
		setNewCustChainView(false);
		if (!_.isEmpty(data)) {
			const normalized = normalizeCustChain(data);
			const newId = getCustChainId(normalized);
			setCustChainOptions((prev) => {
				if (!newId) {
					return prev || [];
				}
				if ((prev || []).some((p) => getCustChainId(p) === newId)) {
					return prev || [];
				}
				return [normalized, ...(prev || [])];
			});
			applyCustChain(normalized);
			if (customer?.cust_code) {
				editCustomer({cust_chain: newId}, true);
			}
			loadCustChainList().then((list) => {
				if (!newId) {
					return;
				}
				const matched = list.find((x) => getCustChainId(x) === newId);
				if (!_.isEmpty(matched)) {
					applyCustChain(matched);
				}
			});
		}
	}

	const loadCustCategoryList = (config = axiosConfig) => {
		const axiosGetConfig = _.isEmpty(config) ? axiosDefaultConfig(gState.client) : config;
		return API_Service.get(req_cust_category, axiosGetConfig)
			.then(({data}) => {
				if (data) {
					var {result, extraData} = data;
					if (parseInt(result) === 1) {
						var _act_data = [];
						for (let i = 0; i < extraData.length; i++) {
							const element = extraData[i];
							if (parseInt(element?.cust_category_status) === 1) {
								_act_data.push(normalizeCustCategory(element));
							}
						}
						setCustCategoryOptions((prev) => {
							const extra = (prev || []).filter((p) => !_act_data.some((i) => getCustCategoryId(i) === getCustCategoryId(p)));
							return [..._act_data, ...extra];
						});
						return _act_data;
					}
				}
				return [];
			})
			.catch((err) => {
				de(err.message, 'customer category list');
				return [];
			});
	}

	const applyCustCategory = (category) => {
		const normalized = normalizeCustCategory(category);
		if (_.isEmpty(normalized)) {
			setCustCategory({});
			setCustCategoryName(empty);
			setCustCategoryId(0);
			return;
		}
		setCustCategory(normalized);
		setCustCategoryName(normalized?.cust_category_name || empty);
		setCustCategoryId(normalized?.cust_category_id || 0);
	}

	const onAddCustCategoryClose = (data) => {
		setNewCustCategoryView(false);
		if (!_.isEmpty(data)) {
			const normalized = normalizeCustCategory(data);
			const newId = getCustCategoryId(normalized);
			setCustCategoryOptions((prev) => {
				if (!newId) {
					return prev || [];
				}
				if ((prev || []).some((p) => getCustCategoryId(p) === newId)) {
					return prev || [];
				}
				return [normalized, ...(prev || [])];
			});
			applyCustCategory(normalized);
			if (customer?.cust_code) {
				editCustomer({cust_category: newId}, true);
			}
			loadCustCategoryList().then((list) => {
				if (!newId) {
					return;
				}
				const matched = list.find((x) => getCustCategoryId(x) === newId);
				if (!_.isEmpty(matched)) {
					applyCustCategory(matched);
				}
			});
		}
	}

	useEffect(() => {
		if(currentInput){
			setCustName(autoCapsOutletName ? currentInput?.outlet_name.toUpperCase() : currentInput?.outlet_name);
			setCustAddress1(currentInput?.outlet_address);
			setMobileCheckinID(currentInput?.mobile_checkin_id);
			setSpValue(currentInput?.salespersonCode);
			setSpSelected(currentInput?.salespersonName);
			setSelectedBranch([currentInput?.salespersonBranch]);
			setSpSelectBranch([currentInput?.salespersonBranch]);

			if (currentInput.customerCategory !== null) {
				setCustCategory(currentInput?.customerCategory);
				setCustCategoryName(currentInput?.customerCategory['cust_category_name']);
				setCustCategoryId(currentInput?.customerCategory['cust_category_id']);
			}else{
				setCustCategory({});
				setCustCategoryName('');
				setCustCategoryId('');
			}

			if (currentInput.outletCity !== null) {
				setCity(currentInput?.outletCity);
			}else{
				setCity('');
			}
			if (currentInput.outletState !== null) {
				setState(currentInput?.outletState);
			}else{
				setState('');
			}
			if (currentInput.outletZipcode !== null) {
				setPostCode(currentInput?.outletZipcode);
			}else{
				setPostCode('');
			}
			if (currentInput.outletCountry !== null) {
				setCountry(currentInput?.outletCountry);
			}else{
				setCountry('');
			}

			const srcLat = currentInput.outletLatitude;
			const srcLng = currentInput.outletLongitude;

			const hasLatitude = Boolean(srcLat);
			const hasLongitude = Boolean(srcLng);

			if (hasLatitude && hasLongitude) {
				setLatlong(`${srcLat} , ${srcLng}`);
			} else if (hasLatitude) {
				setLatlong(`${srcLat}` + ' , 0 ');
			} else if (hasLongitude) {
				setLatlong(' 0 , ' + `${srcLng}`);
			} else {
				setLatlong('0 , 0');
			}
		}
	}, [currentInput]);

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

	const getCountry = (config = axiosConfig) => {
		API_Service.get(req_module_setting, config).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				const country = getSetting(extraData, 'country');
				let country_arr = [JSON.parse(JSON.stringify(country))];
				setCountries(country_arr);

				if(!currentInput){
					const _config = getSetting(extraData, 'customization', {});
					if(_config.custCodeRef){
						setNextCustCode(_config.custCodeRef + _config.custNextRunningNo);
						if(!customer){
							setCustCode(_config.custCodeRef + _config.custNextRunningNo);
						}
					}
					if(_config.customer_code){
						setCustCodeProps(_config.customer_code);
					}
				}

				const _customization = getSetting(extraData, 'customization');
				if (_customization.autoCapsOutletName) {
					setAutoCapsOutletName(true);
				}
			} else {
				snack(language.not_found_salesperson, 'warning');
			}
		});
	}

	const getSalesmanList = (config = axiosConfig) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, config).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {name, staff_code, login, login_status, company} = extraData[idx];
					_data.push({name: name, secondary: login, value: staff_code, status: parseInt(login_status), company: company});
				}
				setSPlist(splist => (_data));
			} else {
				snack(language.not_found_salesperson, 'warning');
			}
		});
	}

	const closeRemove = (data) => {
		setCustCode(empty);
		setCustName(empty);
		setState(empty);
		setSpSelected(empty);
		setSpValue(empty);
		setCustAddress1(empty);
		setCustAddress2(empty);
		setCity(empty);
		setPostCode(empty);
		setCountry(empty);
		setRegion(empty);
		setLatitude(empty);
		setLongitude(empty);
		// setOutletType(empty);
		// setCustomer(data[0]);
		setCustCategory({});
		setCustChain({});
		setCustCategoryName(empty);
		setCustChainName(empty);
		setCustCategoryId(0);
		setCustChainId(0);
		setCustType({});
		setCustTypeName(empty);
		setCustTypeId(0);
		setCustAreaCode(empty);
		setCustAreaName(empty);
		setCustArea({});
		setSelectedStockTemplates([]);
		setStockTemplateNames(empty);
		setStockTemplateIds([]);
		onClose(data);
	}

	const addNewCustomer = () => {
		let formData = new FormData();
		formData.append('cust_code', custCode);
		formData.append('cust_company_name', custName);
		formData.append('billing_address1', custAddress1);
		formData.append('billing_address2', custAddress2);
		formData.append('billing_state', state);
		formData.append('billing_city', city);
		formData.append('billing_zipcode', postCode);
		formData.append('billing_country', country);
		formData.append('salesperson', spValue);
		const latlongArray = latlong.split(',');
		formData.append('longitude', latlongArray[1]);
		formData.append('latitude', latlongArray[0]);
		// formData.append('latlong', latlong);
		formData.append('region', region);
		formData.append('cust_category', custCategoryId);
		formData.append('cust_chain', custChainId);
		formData.append('cust_type', custTyperId);
		formData.append('cust_area', custAreaCode);
		formData.append('company', selectedBranch);
		formData.append('stock_template_ids', stockTemplateIds.join(','));
		// formData.append('type',outletType);

		if(currentInput){
			formData.append('checkin_id', mobileCheckinID);
			if (custName === empty || custAddress1 === empty || custAreaCode === empty) {
				snack('Insert Outlet Name and Address and Customer Area', 'warning');
			} else {
				API_Service.post(req_cust_approve, formData, axiosConfig).then(({data}) => {
					const {result, message, extraData} = data;
					if (result) {
						snack(gState.translation.insert_success);
						closeRemove(extraData);
					} else {
						snack(message, 'warning');
					}
				});
			}
		}else{
			if (custName === empty || custAddress1 === empty || custAreaCode === empty) {
				snack('Insert Outlet Name and Address and Customer Area', 'warning');
			} else {
				API_Service.post(req_cust_insert, formData, axiosConfig).then(({data}) => {
					const {result, message, extraData} = data;
					if (result) {
						snack(gState.translation.insert_success);
						closeRemove(extraData);
					} else {
						snack(message, 'warning');
					}
				});
			}
		}
	}

	// overrides: lookup IDs that were just picked/created; state setters are async, so pass them explicitly
	// keepOpen: auto-save from an add (new Area/Category/Chain/Type) — the window stays open until the user closes it
	const editCustomer = (overrides = {}, keepOpen = false) => {
		const latlongArray = latlong.split(',');
		const values = {
			cust_category: custCategoryId,
			cust_chain: custChainId,
			cust_type: custTyperId,
			cust_area: custAreaCode,
			...overrides,
		};
		const params = axiosURIencode({
			ori_cust_code: customer?.cust_code,
			cust_code: custCode,
			cust_company_name: custName,
			billing_address1: custAddress1,
			billing_address2: custAddress2,
			billing_state: state,
			billing_city: city,
			billing_zipcode: postCode,
			billing_country: country,
			salesperson: spValue,
			longitude: latlongArray[1],
			latitude: latlongArray[0],
			// latlong: latlong,
			region: region,
			cust_category: values.cust_category,
			cust_chain: values.cust_chain,
			cust_type: values.cust_type,
			cust_area: values.cust_area,
			company: selectedBranch,
			stock_template_ids: stockTemplateIds.join(','),
		});
		console.log('EDIT', params);
		// display: picked names for the details view, in case the save response lacks them
		const typeName = overrides.display?.cust_type_name ?? custType?.name;
		const displayNames = typeName ? {cust_type_name: typeName} : {};

		if (custCode === empty || custName === empty || custAddress1 === empty || !values.cust_area) {
			snack('Insert Outlet Code, Outlet Name and Address and Customer Area', 'warning');
		} else {
			API_Service.put(req_cust_insert, params, axiosConfig).then(({data}) => {
				const {result, extraData} = data;
				if (result) {
					snack(gState.translation.record_updated);
					// 更新当前客户状态以反映后端返回的最新数据
					// display: names of just-picked items, so the details view shows them even if the response lacks them
					const savedRows = extraData && extraData.length > 0 ? [{...extraData[0], ...displayNames}] : extraData;
					if (savedRows && savedRows.length > 0) {
						const updatedCustomer = savedRows[0];
						setCustomer(updatedCustomer);
						
						// 重新处理 tmplt_data 来更新组件状态
						if (updatedCustomer.tmplt_data && Array.isArray(updatedCustomer.tmplt_data)) {
							const selectedTemplates = [];
							const templateNames = [];
							const templateIds = [];
							
							for (let i = 0; i < updatedCustomer.tmplt_data.length; i++) {
								const tmpltData = updatedCustomer.tmplt_data[i];
								// 在 stockTemplateList 中查找对应的完整模板对象
								for (let k = 0; k < stockTemplateList.length; k++) {
									const element = stockTemplateList[k];
									// 兼容 id 和 tmplt_id 两种字段名
									const tmpltId = tmpltData.tmplt_id || tmpltData.id;
									if(element.id == tmpltId){
										selectedTemplates.push(element);
										templateNames.push(element.tmplt_name);
										templateIds.push(element.id.toString());
										break;
									}
								}
							}
							
							setSelectedStockTemplates(selectedTemplates);
							setStockTemplateNames(templateNames.join(', '));
							setStockTemplateIds(templateIds);
						}
					}
					if (keepOpen) {
						onSaved && onSaved(savedRows);
					} else {
						closeRemove(savedRows);
					}
				} else {
					snack(data.message, 'warning');
				}
			});
		}
	}

	const spViewClick = () => {
		setSpView(true);
	}

	const spViewClose = (newValue) => {
		setSpView(false);
		if (newValue) {
			var spValue = '';
			var spName = '';
			var spBranch = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spValue += newValue[i].value;
					spName += newValue[i].name;
					spBranch += newValue[i].company;
				} else {
					spValue += newValue[i].value + ",";
					spName += newValue[i].name + ",";
					spBranch += newValue[i].company + ",";
				}
			}
			spBranch = [...new Set(spBranch.split(","))].join(",");
			setSpValue(spValue);
			setSpSelected(spName);
			if (newValue.length == 0 && gState.company) {
				return;
			}else{
				setSelectedBranch(spBranch.split(","));
				setSpSelectBranch(spBranch.split(","));
			}
		} else {
			// setSpValue(empty);
			// setSpSelected(empty);
		}
	}

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<Dialog fullScreen={fullScreen} onClose={closeRemove} aria-labelledby="simple-dialog-title" open={open}>
			<DialogTitle id="simple-dialog-title">
				{customer ? language.edit_customer : language.add_customer}
			</DialogTitle>
			<div style={{width: 600, padding: theme.spacing(2)}}>
				<div className={classes.viewInRowSpace}>
					<TextField
						id="input-cust-name"
						style={{width: '48%', height: 50}}
						inputProps={{maxLength: custCodeProps, pattern: "[a-z]{1,15}"}}
						label={language.cust_code}
						value={custCode == empty ? nextCustCode : custCode}
						// disabled={currentCustomer != null ? true : false}
						onChange={(e) => setCustCode(e.target.value)}
					/>
					<TextField
						id="input-cust-name"
						style={{width: '48%', height: 50}}
						label={language.outlet_name}
						value={custName}
						onChange={(e) => setCustName(autoCapsOutletName ? e.target.value.toUpperCase() : e.target.value)}
						inputProps={{ style: { textTransform: autoCapsOutletName ? "uppercase" : "none" } }}
					/>
					<TextField
						id="input-cust-address1"
						style={{width: '48%', height: 50}}
						label={language.address1}
						value={custAddress1}
						onChange={(e) => setCustAddress1(e.target.value)}
					/>
					<TextField
						id="input-cust-address2"
						style={{width: '48%', height: 50}}
						label={language.address2}
						value={custAddress2}
						onChange={(e) => setCustAddress2(e.target.value)}
					/>
					<FormControl style={{width: '48%', height: 50}}>
						<InputLabel id="demo-simple-select-label">{language.country}</InputLabel>
						<Select
							value={country}
							onChange={(e) => setCountry(e.target.value)}
						>
							{countries.map((country, idx) => (
								<MenuItem
									value={country.countryName}
									key={country.countryShortCode+idx+country.countryName}
								>
									{country.countryName}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl style={{width: '48%', height: 50}}>
						<InputLabel id="demo-simple-select-label">{language.state}</InputLabel>
						<Select
							value={state}
							onChange={(e) => setState(e.target.value)}
							disabled={!country}
						>
							{country
								? countries
									?.find(({countryName}) => countryName === country)
									?.states.map((states) => (
										<MenuItem value={states.name}>
											{states.name}
										</MenuItem>
									))
								: []}
						</Select>
					</FormControl>
					<FormControl style={{width: '48%', height: 50}}>
						<InputLabel id="demo-simple-select-label">{language.region}</InputLabel>
						<Select
							value={region}
							onChange={(e) => setRegion(e.target.value)}
							disabled={!country}
						>
							{country
								? countries
									?.find(({countryName}) => countryName === country)
									?.regions.map((regions) => (
										<MenuItem value={regions.name}>
											{regions.name}
										</MenuItem>
									))
								: []}
						</Select>
					</FormControl>
					<TextField
						id="input-cust-city"
						style={{width: '48%', height: 50}}
						label={language.city}
						value={city}
						onChange={(e) => setCity(e.target.value)}
					/>
					<TextField
						id="input-cust-postcode"
						style={{width: '48%', height: 50}}
						InputProps={{
							inputComponent: NumberFormatCustom,
						}}
						label={language.zipcode}
						value={postCode}
						onChange={(e) => setPostCode(e.target.value)}
					/>
					{
						branchesList.length > 0 && (
							<>
								<FormControl style={{width: '48%', height: 50}}>
									<InputLabel id="demo-simple-select-label">Branch</InputLabel>
									<Select
										disabled={gState.company}
										value={selectedBranch}
										onChange={(e) => {
											setSelectedBranch(e.target.value);
											// setEdited(true);
										}}
										multiple
									>
										{branchesList.map((data) => (
											<MenuItem
												value={data.value}
												key={data.value}
											>
												{data.name.toUpperCase()}
											</MenuItem>
										))}
									</Select>
								</FormControl>
								
							</>
						)
					}
					<div style={{width: '48%'}}/>
					<TextField
						id="input-cust-latitude-longitude"
						style={{width: '100%', height: 50}}
						// InputProps={{
						// 	inputComponent: NumberFormatCustom,
						// }}
						label={language.latitude +' , '+ language.longitude}
						value={latlong}
						onChange={(e) => setLatlong(e.target.value)}
					/>
				</div>
			<div style={{height: 20}}/>
			<Autocomplete
				autoHighlight
				className={classes.btn}
				options={custAreaOptions || []}
				getOptionSelected={(option, value) => getCustAreaCode(option) === getCustAreaCode(value)}
				onChange={(event, newValue) => {
					applyCustArea(newValue);
				}}
				value={custArea}
				inputValue={custAreaName}
				onInputChange={(event, newInputValue) => {
					setCustAreaName(newInputValue);
				}}
				noOptionsText={
					<div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
						<Typography variant={'body2'}>{language.no_data}</Typography>
						{/* <Button
							size={'small'}
							color={'primary'}
							onMouseDown={(e) => e.preventDefault()}
							onClick={() => setNewCustAreaView(true)}>
							{language.add}
						</Button> */}
					</div>
				}
				getOptionLabel={(option) => option?.area_name || option?.name || ""}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Customer Area"
						variant="outlined"
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{params.InputProps.endAdornment}
									<Tooltip title={language.add}>
										<IconButton
											size={'small'}
											onMouseDown={(e) => e.preventDefault()}
											onClick={() => setNewCustAreaView(true)}>
											<AddIcon fontSize={'small'} />
										</IconButton>
									</Tooltip>
								</>
							)
						}}
					/>
				)}
			/>
				<div style={{height: 20}}/>
			<Autocomplete
				autoHighlight
				className={classes.btn}
				options={custCategoryOptions || []}
				getOptionSelected={(option, value) => getCustCategoryId(option) === getCustCategoryId(value)}
				onChange={(event, newValue) => {
					applyCustCategory(newValue);
				}}
				onInputChange={(event, newInputValue) => {
					setCustCategoryName(newInputValue);
				}}
				value={custCategory}
				inputValue={custCategoryName}
				noOptionsText={
					<div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
						<Typography variant={'body2'}>{language.no_data}</Typography>
						{/* <Button
							size={'small'}
							color={'primary'}
							onMouseDown={(e) => e.preventDefault()}
							onClick={() => setNewCustCategoryView(true)}>
							{language.add}
						</Button> */}
					</div>
				}
				getOptionLabel={(option) => option?.cust_category_name || option?.name || ""}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Customer Category"
						variant="outlined"
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{params.InputProps.endAdornment}
									<Tooltip title={language.add}>
										<IconButton
											size={'small'}
											onMouseDown={(e) => e.preventDefault()}
											onClick={() => setNewCustCategoryView(true)}>
											<AddIcon fontSize={'small'} />
										</IconButton>
									</Tooltip>
								</>
							)
						}}
					/>
				)}
			/>
				<div style={{height: 20}}/>
				<Autocomplete
					autoHighlight
					className={classes.btn}
					options={custChainOptions || []}
					getOptionSelected={(option, value) => getCustChainId(option) === getCustChainId(value)}
					onChange={(event, newValue) => {
						applyCustChain(newValue);
					}}
					value={custChain}
					inputValue={custChainName}
					onInputChange={(event, newInputValue) => {
						setCustChainName(newInputValue);
					}}
					noOptionsText={
						<div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
							<Typography variant={'body2'}>{language.no_data}</Typography>
							{/* <Button
								size={'small'}
								color={'primary'}
								onMouseDown={(e) => e.preventDefault()}
								onClick={() => setNewCustChainView(true)}>
								{language.add}
							</Button> */}
						</div>
					}
					getOptionLabel={(option) => option?.cust_chain_name || option?.name || ""}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Customer Chain"
							variant="outlined"
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<>
										{params.InputProps.endAdornment}
										<Tooltip title={language.add}>
											<IconButton
												size={'small'}
												onMouseDown={(e) => e.preventDefault()}
												onClick={() => setNewCustChainView(true)}>
												<AddIcon fontSize={'small'} />
											</IconButton>
										</Tooltip>
									</>
								)
							}}
						/>
					)}
				/>
				<div style={{height: 20}}/>
			<Autocomplete
				autoHighlight
				className={classes.btn}
				options={custTypeOptions || []}
				getOptionSelected={(option, value) => getCustTypeId(option) === getCustTypeId(value)}
				onChange={(event, newValue) => {
					applyCustType(newValue);
				}}
				value={custType}
				inputValue={custTypeName}
				onInputChange={(event, newInputValue) => {
					setCustTypeName(newInputValue);
				}}
				noOptionsText={
					<div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
						<Typography variant={'body2'}>{language.no_data}</Typography>
						{/* <Button
							size={'small'}
							color={'primary'}
							onMouseDown={(e) => e.preventDefault()}
							onClick={() => setNewCustTypeView(true)}>
							{language.add}
						</Button> */}
					</div>
				}
				getOptionLabel={(option) => option?.name || option?.cust_type_name || ""}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Customer Type"
						variant="outlined"
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{params.InputProps.endAdornment}
									<Tooltip title={language.add}>
										<IconButton
											size={'small'}
											onMouseDown={(e) => e.preventDefault()}
											onClick={() => setNewCustTypeView(true)}>
											<AddIcon fontSize={'small'} />
										</IconButton>
									</Tooltip>
								</>
							)
						}}
					/>
				)}
			/>
				<div style={{height: 20}}/>
				<Autocomplete
					multiple
					autoHighlight
					className={classes.btn}
					options={stockTemplateList || []}
					onChange={(event, newValue) => {
						setSelectedStockTemplates(newValue);
						const names = newValue.map(template => template.tmplt_name);
						const ids = newValue.map(template => template.id);
						setStockTemplateNames(names.join(', '));
						setStockTemplateIds(ids);
					}}
					value={selectedStockTemplates}
					noOptionsText={language.no_data}
					getOptionLabel={(option) => option.tmplt_name || ""}
					renderInput={(params) => <TextField {...params} label="Stock Template" variant="outlined"/>}
				/>
				<div style={{height: 20}}/>
				<Button
					size="small"
					variant="outlined"
					onClick={() => spViewClick()}
					style={{width: '100%', height: 50}}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography component="p" className={commonStyle.searchBtnFont}>
						{spSelect ? _.truncate(spSelect, {length: 20}) : language.salesman}
					</Typography>
				</Button>
				<div style={{height: 20}}/>
				<div style={{display: "flex"}}>
					{
						typeof onCancel === 'function' && (
							<Button
								className={classes.error}
								style={{marginLeft: 'auto'}}
								variant="outlined"
								onClick={() => {
									onCancel()
								}}
								color={'primary'}>
								{language.cancel}
							</Button>
						)
					}
					<Button
						style={{marginLeft: typeof onCancel === 'function' ? 10 : 'auto'}}
						disabled={
							(branchesList.length > 0 && cannotADDorEDIT === true) || (spSelect.value != 0 ? false : true)
						}
						variant="outlined"
						onClick={() => {
							customer ? editCustomer() : addNewCustomer()
						}}
						color={'primary'}>
						{customer ? language.edit : language.add}
					</Button>
				</div>
				<div style={{height: 20}}/>
			</div>
			<VirtualListCB2
				open={spView}
				setClose={data => spViewClose(data)}
				title={language.salesman}
				data={splist}
				language={language}
				filteration={0}
				enabledCheckAll={false}
			/>
			<AddAreaType
				open={newCustAreaView}
				onClose={(data) => onAddCustAreaClose(data)}
				language={language}
				onSnack={(msg, type) => snack(msg, type)}
				axiosConfig={axiosConfig}
			/>
			<AddCustType
				open={newCustTypeView}
				onClose={(data) => onAddCustTypeClose(data)}
				language={language}
				onSnack={(msg, type) => snack(msg, type)}
				axiosConfig={axiosConfig}
			/>
			<AddCustChain
				open={newCustChainView}
				onClose={(data) => onAddCustChainClose(data)}
				language={language}
				onSnack={(msg, type) => snack(msg, type)}
				axiosConfig={axiosConfig}
			/>
			<AddCustCategory
				open={newCustCategoryView}
				onClose={(data) => onAddCustCategoryClose(data)}
				language={language}
				onSnack={(msg, type) => snack(msg, type)}
				axiosConfig={axiosConfig}
				mobileCustomization={{}}
			/>
		</Dialog>
	)
}

function CurrencyFormatCustom(props) {
	const {inputRef, onChange, ...other} = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			thousandSeparator={true}
			isNumericString
			prefix={'RM'}
			min={0}
			max={999999}
		/>
	);
}

NumberFormatCustom.propTypes = {
	inputRef: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

function NumberFormatCustom(props) {
	const {inputRef, onChange, ...other} = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						// value: values.value,
						value: values.formattedValue,
					},
				});
			}}
			thousandSeparator={false}
			// isNumericString
			// min={0}
			// max={999999}
			format="######"
			allowNegative={false}
		/>
	);
}
